import React, { useEffect, useState } from "react"
import { Button, Descriptions, Drawer, Input, InputNumber, message } from "antd"
import { EditOutlined } from "@ant-design/icons"
import { doc, updateDoc } from "firebase/firestore"
import { db } from "../../../firebase/config"

const { TextArea } = Input

const initVal = null

export default function EditDoneOrder({ record }) {
  const [open, setOpen] = useState(false)
  const [totalUsedMeters, setTotalUsedMeters] = useState(null)
  const [finishComment, setFinishComment] = useState(null)

  // Update order
  const updateOrder = async () => {
    // Reference the specific document using doc
    const orderRef = doc(db, "orders", record.id)

    try {
      await updateDoc(orderRef, {
        "machineCompletion.usedMeters": totalUsedMeters,
        "machineCompletion.finishComment": finishComment,
        // Update other fields as necessary
      })
      message.success("Order updated successfully!")
      onClose()
    } catch (err) {
      message.error("Error updating order, check logs")
      console.error(err)
    }
  }

  const showDrawer = () => {
    setOpen(true)
  }
  const onClose = () => {
    setOpen(false)
    setTotalUsedMeters(initVal)
    setFinishComment(initVal)
  }

  //change total used meters
  const handleUsedMeters = (value) => {
    setTotalUsedMeters(value)
  }

  useEffect(() => {
    if (open) {
      setTotalUsedMeters(record.machineCompletion.usedMeters)
      setFinishComment(record.machineCompletion.finishComment)
    }
  }, [open, record])

  return (
    <>
      <Button
        disabled={record.orderStatus >= 7 ? true : false}
        size="small"
        icon={<EditOutlined />}
        type="link"
        onClick={showDrawer}></Button>
      <Drawer title={record.selectedProduct.product.productName} onClose={onClose} open={open}>
        <Descriptions column={1}>
          <Descriptions.Item label="Total Used Meters">
            <InputNumber size="small" value={totalUsedMeters} onChange={handleUsedMeters} />
          </Descriptions.Item>
          <Descriptions.Item label="Finish comment">
            <TextArea
              placeholder="comment here..."
              size="small"
              value={finishComment}
              rows={6}
              onChange={(event) => setFinishComment(event.target.value)}
            />
          </Descriptions.Item>
        </Descriptions>
        <Button
          onClick={updateOrder}
          disabled={record.orderStatus >= 7 ? true : false}
          type="primary"
          block>
          Update
        </Button>
      </Drawer>
    </>
  )
}
